module.exports = __webpack_public_path__ + "img/changeboxbutton.cf6f8027.png";